var map = {
	"./Braile.png": 8293,
	"./Cadeirante.png": 9469,
	"./Caption.png": 5159,
	"./Libras.png": 1340,
	"./Surdo.png": 4895,
	"./Text.png": 7911,
	"Assets/Common/Accessiblity/Braile.png": 8293,
	"Assets/Common/Accessiblity/Cadeirante.png": 9469,
	"Assets/Common/Accessiblity/Caption.png": 5159,
	"Assets/Common/Accessiblity/Libras.png": 1340,
	"Assets/Common/Accessiblity/Surdo.png": 4895,
	"Assets/Common/Accessiblity/Text.png": 7911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1438;